import React from "react";
interface AddressItemProps {
  address: string;
  wardName: string;
  districtName: string;
  provinceName: string;
  addressId: string | number;
  addressIdUseCart: string | number;
  name: string;
  phone: string;
  onSelect: (addressId: string| number) => void;
  onEdit: (addressId: string | number) => void;
  onRemove: (addressId: string | number) => void;
}
export const AddressItemComponent = (props: AddressItemProps) => {
  const {
    address,
    phone,
    wardName,
    districtName,
    provinceName,
    name,
    addressId,
    addressIdUseCart,
    onEdit,
    onRemove,
    onSelect
  } = props;
  return (
    address ? (  
      <div
        className={`panel panel-default address-item ${
          addressId === addressIdUseCart && `is-default`
        }`}
      >
        <div className="panel-body">
          <p className="name">{name}</p>
          <p className="phone">{phone}</p>
          <p
            className="address"
            title={`${address} ${wardName !== null ?`, ${wardName}`: ``}, ${districtName} ${provinceName}`}
          >
            Địa chỉ: {`${address} ${wardName !== null ?`, ${wardName}`: ``}, ${districtName}`}
          </p>
          <p className="address">{provinceName} </p>
          <p className="action">
            <button
              onClick={(ev) => {
                ev.preventDefault();
                onSelect(addressId);
              }}
              className={`btn ${addressIdUseCart === addressId ? `btn-primary`: `btn-default`}`}
            >
             Chọn địa chỉ này 
            </button>
            <button
              onClick={(ev) => {
                ev.preventDefault();
                onEdit(addressId);
              }}
              className="btn btn-default"
            >
              Sửa
            </button>
            <button
              onClick={(ev) => {
                ev.preventDefault();
                onRemove(addressId);
              }}
              className="btn btn-default"
            >
              Xóa
            </button>
          </p>
          {addressIdUseCart === addressId && (
            <span className="default">Mặc định</span>
          )}
        </div>
      </div>
    ):null
  );
};
